import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    padding-inline: 15px;
`;

export const BarContainer = styled.div`
    display: flex;
    width: 40px;
    height: 100%;
    flex-direction: column;
    justify-content: flex-end;
    background: #F6F6F6;
    border-radius: 10px;
    @media (min-width: 720px) {
        width: 60px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        width: 40px;
    }
`;

export const ContentContainer = styled.div`
    background: #F3CC9F;
    border-radius: 10px;
    width: 40px;
    height: ${props => props.$height ? props.$height : '0%'};
    @media (min-width: 720px) {
        width: 60px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        width: 40px;
    }
`;

export const NameText = styled.span`
    display: flex;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    @media (min-width: 720px) {
        font-size: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 14px;
    }
`;

export const TextSoma = styled.span`
    position: absolute;
    display: flex;
    font-size: 12px;
    font-weight: 700;
    color: #464646;
    right: 10px;
    @media (min-width: 720px) {
        font-size: 16px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 12px;
    }
`;